import * as React from "react";
const SvgFiRrNairaSign = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-naira-sign_svg__a)">
      <path
        fill="#062147"
        d="M23 11h-1V1c0-.55-.45-1-1-1s-1 .45-1 1v10h-7.45L6.14 1.03A2.25 2.25 0 0 0 3.61.09C2.65.37 2 1.24 2 2.25V11H1c-.55 0-1 .45-1 1s.45 1 1 1h1v10c0 .55.45 1 1 1s1-.45 1-1V13h7.45l6.41 9.97c.42.66 1.13 1.03 1.88 1.03a2.232 2.232 0 0 0 2.25-2.25V13h1c.55 0 1-.45 1-1s-.45-1-1-1zM4 11V2.25s0-.18.18-.24.25.06.28.1L10.17 11zm16 10.75s0 .18-.18.24-.25-.06-.28-.1L13.83 13H20z"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-naira-sign_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrNairaSign;
